import React from "react";
import { observer, inject } from "mobx-react";

import { Heading } from "grommet";

import BookElement from "app/api/bookElement";

import SectionBreak from "app/components/BookElements/SectionBreak";
import TableOfContentsEntry from "app/components/BookElements/TableOfContentsEntry";
import Paragraph from "app/components/Paragraph";
import Anchor from "app/components/Anchor";

class Information extends React.Component {
  render() {
    const { path } = this.props;
    if (BookElement.isNotSelected(path)) return null;

    return (
      <React.Fragment>
        <TableOfContentsEntry path={path}>
          <Heading responsive textAlign="center">
            Information
          </Heading>
        </TableOfContentsEntry>
        <Paragraph>
          This pamphlet is available in electronic media at the TRADOC
          Administrative Publications website at (
          <Anchor href="https://adminpubs.tradoc.army.mil/index.html">
            https://adminpubs.tradoc.army.mil/
          </Anchor>
          ) and hardcopy to the four Army training locations that conduct BCT
          and OSUT.
        </Paragraph>
        <Paragraph>
        This pamphlet introduces Solders to the Army Ethic, Values, Culture of Trust, History, Organizations, and Training. It provides information on pay, leave, Thrift Saving Plans (TSPs), and organizations that will be available to assist you and your Families. The Soldier’s Blue Book is mandated reading and will be maintained and available during BCT/OSUT and AIT. 
        </Paragraph>
        <Paragraph>
        Applicability. This pamphlet applies to all active Army, U.S. Army Reserve, and the Army National Guard enlisted IET conducted at service schools, Army Training Centers, and other training activities under the control of Headquarters, TRADOC.Proponent. The proponent for this pamphlet is TRADOC Commanding General U.S. Army Center for Initial Military Training (USACIMT) (ATMT-OP), 210 Dillon Circle, Fort Eustis VA 23604-5701. 
        </Paragraph>
        <Paragraph>
        Supplementation. Users are invited to send comments and suggested improvements on Department of the Army (DA) Form 2028 (Recommended Changes to Publications and Blank Forms) directly to the U.S. Army Center for nitial Military Training (ATMT-OP), 210 Dillon Circle, Fort Eustis, VA 23604-5701, usarmy.jble.tradoc.mbx.dcg-imt-g7@mail.mil. 
        </Paragraph>
        <SectionBreak />
      </React.Fragment>
    );
  }
}

const Component = inject("AppState")(observer(Information));
Component.displayName = "Information";
export const InformationComponent = Information;
export default Component;



// WEBPACK FOOTER //
// ./src/app/components/BookElements/Information.js